import CommunityMapSection from '@/components/CommunityMapSection/CommunityMapSection';
import FloorPlansFilters from '@/components/FloorPlansFilters/FloorPlansFilters';
import Hero from '@/components/Hero/Hero';
import PropertiesGrid from '@/components/PropertiesGrid/PropertiesGrid';
import { useAppContext } from '@/contexts/AppContext';
import type { Unit } from '@/domain/units';
import { useUnits } from '@/hooks/units';
import { useState, type FC } from 'react';

const FloorPlansPage: FC = () => {
  const { community } = useAppContext();
  const { data: units } = useUnits.useSuspenseQuery([community.id]);
  const [filteredUnits, setFilteredUnits] = useState<Unit[]>([]);

  return (
    <div>
      <Hero
        title="Available Floor Plans"
        subtitle="Find your perfect home from our collection of beautifully designed floor plans"
        showCTA={false}
      />

      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <FloorPlansFilters units={units} setFilteredUnits={setFilteredUnits} />

          <PropertiesGrid units={filteredUnits} />
        </div>
      </section>

      <CommunityMapSection />
    </div>
  );
};

export default FloorPlansPage;
